export enum PlaceSearchStateEnum {
  DISPLAYCATEGORIES = 'categories',
  SEARCHLANDING = 'search',
  SEARCHING = 'searching',
  DISPLAYPLACES = 'locations',
  NOTFOUND = 'notfound',
  CATAGORYFILTERED = 'categoryfiltered',
}
